export const variants = ['juniper', 'aqua', 'robin', 'honey', 'cherry', 'vanilla-dark']
